import React from "react";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { generateBookVisitUrl, isBookVisitLink } from "utils/bookvisit-link-helpers";

import WP from "WP";

const SmartLink = (props) => {
  const { to, target, children, className, onClick, exact } = props;

  if (!to) return '"to" prop is required';

  const internal = to.indexOf(WP.home) !== -1 || to[0] === "/";

  // if link is internal - remove the domain
  let url = internal ? to.replace(WP.home, "") : to;

  if (isBookVisitLink(url)) {
    const bookVisitUrl = generateBookVisitUrl(url);
    if (bookVisitUrl) {
      return (
        <a className={className} onClick={(e) => (onClick ? onClick(e) : false)} href={bookVisitUrl}>
          {children}
        </a>
      );
    }
  }

  // make sure internal links start from '/'
  if (internal && url[0] !== "/") url = "/" + url;

  // make sure english links start form /en/
  if (internal && WP.lang === "en" && url.indexOf("/" + WP.lang + "/") === -1) url = "/" + WP.lang + url;

  return internal ? (
    <NavLink className={className} onClick={(e) => (onClick ? onClick(e) : false)} to={url} exact={exact}>
      {children}
    </NavLink>
  ) : (
    <a
      className={className}
      onClick={(e) => (onClick ? onClick(e) : false)}
      href={url}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
    >
      {children}
    </a>
  );
};

export default withRouter(SmartLink);
